import type { Composer } from 'vue-i18n';
import { useI18n } from 'vue-i18n';

export function useModuleI18n<EnglishLocale, FrenchLocale>(
  enLocale: EnglishLocale,
  frLocale: FrenchLocale,
): { mergeLocaleMessage: Composer['mergeLocaleMessage'] } {
  const { mergeLocaleMessage } = useI18n<{ en: EnglishLocale; fr: FrenchLocale }, 'en' | 'fr'>();

  mergeLocaleMessage('en', enLocale);
  mergeLocaleMessage('fr', frLocale);

  return { mergeLocaleMessage };
}
